import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './TermsAndConditions.css';

function TermsAndConditions() {
  const [content, setContent] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch('/terms_and_conditions.md')
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="terms-and-conditions">
      <div className="terms-and-conditions-container">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default TermsAndConditions;
